import { ITirPmResizablePanelStyleVars } from "./ITirPmResizablePanelStyleVars";

export class TirPmResizablePanelStyleVars
  implements ITirPmResizablePanelStyleVars
{
  "--tir-pm-resizable-panel__top-indent" = "0.5rem";
  "--tir-pm-resizable-panel__z-index" = "1000";
  "--tir-pm-resizable-panel__shadow" =
    "1.188rem 3.375rem 1rem 0rem rgba(0, 0, 0, 0.00), 0.75rem 2.125rem 0.938rem 0rem rgba(0, 0, 0, 0.01), 0.438rem 1.188rem 0.75rem 0rem rgba(0, 0, 0, 0.05), 0.188rem 0.563rem 0.563rem 0rem rgba(0, 0, 0, 0.09), 0.063rem 0.125rem 0.313rem 0rem rgba(0, 0, 0, 0.10)";
  "--tir-pm-resizable-panel__br" = "0.5rem";
  "--tir-pm-resizable-panel__border" =
    "0.063rem solid var(--neutral-10, #EAEAEB)";
  "--tir-pm-resizable-panel__bg" = "var(--bg-base, #FFF)";
  "--tir-pm-resizable-panel__resize-control-size" = "1.5rem";
  "--tir-pm-resizable-panel__resize-control-bg" =
    "var(--text-primary, #272D37)";
  "--tir-pm-resizable-panel__resize-control-z-index" = "50000";

  static setVars(vars: TirPmResizablePanelStyleVars) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${
        vars[key as keyof TirPmResizablePanelStyleVars]
      };\n`;
    });
    styleElement.textContent = `
  :root {
    ${varsStr}
  }
`;

    document.head.appendChild(styleElement);
  }
}
